export const name = 'hoverBox' as const
export const HoverBoxAPISym = Symbol('HoverBoxAPISym')
export const ComponentType = 'HoverBox'
